import axios from 'axios';
import Cookies from 'js-cookie';

axios.defaults.baseURL = process.env.VUE_APP_PROFILE_ROOT;
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  (config: any) => {
    config.headers['Authorization'] = `Bearer ${Cookies.get('accessToken')}`;
    config.headers['Cache-Control'] = 'no-cache';
    return config;
  },
  async (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (res) => res,
  async (err) => {
    const request = err.config;
    if (err.response?.data.error_code === 401) {
      try {
        const res = await axios.post('/auth/refresh-token', {}, { withCredentials: true });
        const newToken = (res.data as { accessToken: string }).accessToken;
        request.headers['Authorization'] = `Bearer ${newToken}`;
        Cookies.set('accessToken', newToken);

        return axios(request);
      } catch (refreshErr) {
        window.location.href = '/login';
        return Promise.reject(refreshErr);
      }
    }

    return Promise.reject(err);
  },
);